'use client'

import { useMemo } from 'react'

import { AdLeaderboard } from '@/components/common/Ad'
import { ErrorBlock } from '@/components/common/ErrorBlock'
import { PackageFontAwesome } from '@/components/common/PackageFontAwesome'
import { PackageFontMana } from '@/components/common/PackageFontMana'
import { Splash } from '@/components/common/Splash'
import { usePage } from '@/components/providers/PageProvider'
import { ScrollspyProvider } from '@/components/providers/ScrollspyProvider'

import styles from './Guide.module.scss'
import { GuideContent } from './GuideContent/GuideContent'
import { GuideFooter } from './GuideFooter/GuideFooter'
import { GuideHeader } from './GuideHeader/GuideHeader'
import { GuideSidebar } from './GuideSidebar/GuideSidebar'
import { GuideStickyHeader } from './GuideStickyHeader/GuideStickyHeader'

export const Guide = () => {
  const { page } = usePage()
  const article = page?.article
  const slugs = useMemo(() => article?.guide?.flatMap((g) => g.sections.map(({ slug }) => slug)) ?? [], [article])

  if (!article) return <ErrorBlock />

  const { featuredImageUrl } = article

  const srcTextless = featuredImageUrl?.textless

  return (
    <section className={styles.container}>
      <PackageFontMana />
      <PackageFontAwesome />
      <ScrollspyProvider slugs={slugs}>
        {srcTextless && <Splash backgroundImages={[srcTextless]} />}
        <GuideStickyHeader />
        <AdLeaderboard />
        <GuideHeader />
        <div className={styles.inner}>
          <GuideSidebar />
          <GuideContent />
        </div>
        <GuideFooter />
      </ScrollspyProvider>
    </section>
  )
}
